import { ACTUALIZAR_LIST_CHECKLIST, AGREGAR_CHECKLIST, ACTUALIZAR_LIST_CHECKLISTREGS, MODIFICAR_FILTROS_RANGO, MODIFICAR_FILTROS_ESTADOS, MODIFICAR_FILTROS } from "./checklistActions";

  const checklistReducer = (state, action) => {
    switch(action.type){

        case ACTUALIZAR_LIST_CHECKLIST: {
            return {
                ...state,
                checklistList: action.payload
            }
        };
        case ACTUALIZAR_LIST_CHECKLISTREGS: {
            return {
                ...state,
                checklistRegList: action.payload,
                cargandoChecklistRegs: false
            }
        };

         case MODIFICAR_FILTROS: {
            return {
                ...state,
                filtrosEstado: action.payload.filtrosEstado,
                filtrosRango: action.payload.filtrosRango,
                cargandoChecklistRegs:true
            }
        }

        case MODIFICAR_FILTROS_RANGO: {
            return {
                ...state,
                filtrosRango: action.payload.filtrosRango,
                cargandoChecklistRegs:true
            }
        }
        
        case MODIFICAR_FILTROS_ESTADOS: {
            return {
                ...state,
                filtrosEstado: action.payload,
            }
        }
        

        case AGREGAR_CHECKLIST:{
            return {
                 ...state,
                 checklistList: [action.payload, ...state.checklistList]
             }
         };

        default:
            return state;

    }
  }

  export default checklistReducer;